import React, {useState, useCallback, useEffect} from "react";
import './App.css';
import Welcome from './sections/welcome';
import initialConfig from './config/config.js';
import Header from "./sections/components/Header.js";
import axios from 'axios';

function App() {

  useEffect(
    () => {        
        document.getElementsByTagName("body")[0].style.backgroundColor = initialConfig.backgroundColor;
    },[]);

  return (
    <div className="App" style={{backgroundColor: initialConfig.secondaryColor}}>
      <Header/>
      <Welcome/>
    </div>
  );

}

export default App;
